import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Card from "../../components/JobCard";
import { useNavigate, useLocation } from "react-router-dom";
import CircularLoader from "../../components/loader";
import HomeHeader from "../../components/HomeHeader";
import axios from "axios";

function AllMatchingJobs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [allJobList, setAllJobList] = useState({
    CREATED: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const headerTitle = location?.state;

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    if (token) {
      const fetchJobs = async () => {
        try {
          const response = await axios.get("https://jobmanagement-497524552274.us-central1.run.app/api/jobs/list", {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          // Filter only jobs with CREATED status
          const createdJobs = response.data.filter((job) => job.status === "CREATED");

          setAllJobList({ CREATED: createdJobs });
        } catch (err) {
          setError("Failed to fetch jobs. Please try again.");
        } finally {
          setLoading(false);
        }
      };

      fetchJobs();
    }
  }, [token]);

  const handleViewDetails = (jobId) => {
    console.log("Navigating to job details for jobId: ", jobId);  // Check if jobId is correct
    navigate(`/job-details/${jobId}`);
  };

  return (
    <>
      {loading && <CircularLoader position="loaderMiddle" />}
      {error && <div>{error}</div>}
      <Grid margin="5%" bgcolor="#FFFFFF">
        <Grid pb={1} display="flex" alignItems="center">
          <HomeHeader header={headerTitle || "Created Jobs"} />
        </Grid>

        {allJobList.CREATED.length > 0 ? (
          <Grid>
            <h3>CREATED</h3>
            {allJobList.CREATED.map((job, i) => (
              <div key={i}>
                <div>Job ID: {job.id}</div>
                <Card
                  key={i}
                  headerTitle={headerTitle}
                  showTitle={true}
                  profile={false}
                  data={job}
                  onViewDetails={() => handleViewDetails(job.id)}  // Pass jobId to navigate
                />
              </div>
            ))}
          </Grid>
        ) : (
          <p>No jobs with CREATED status found.</p>
        )}
      </Grid>
    </>
  );
}

export default AllMatchingJobs;
